export default __webpack_public_path__ + "files/4687406562c7c9d0b02367c183fdac22.wav";